<ion-fab-button (click)="centerOnUser()" color="light" size="small" class="tw:mr-0">
  <ion-icon src="/assets/svg/target.svg"></ion-icon>
</ion-fab-button>
